import React from 'react';
import styled from 'styled-components';

import { FaTimesCircle } from 'react-icons/fa'

const defaultStyle = {
    borderRadius: '10px',
    backgroundColor: 'var(--secondary-color)',
    color: 'var(--text-color)',
    border: '1px solid var(--primary-accent-color)',
    padding: '0.1rem 0.5rem',
    margin: '0 0.2rem 0.2rem 0',
    fontSize: '0.8rem',
    fontWeight: 'normal',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '2rem',
    cursor: 'auto',
}

const Container = styled.div`
    border-radius: ${props => props.style.borderRadius};
    background-color: ${props => props.style.backgroundColor};
    color: ${props => props.style.color};
    border: ${props => props.style.border};
    padding: ${props => props.style.padding};
    margin: ${props => props.style.margin};
    font-size: ${props => props.style.fontSize};
    font-weight: ${props => props.style.fontWeight};
    border-radius: ${props => props.style.borderRadius};
    display: ${props => props.style.display};
    justify-content: ${props => props.style.justifyContent};
    align-items: ${props => props.style.alignItems};
    min-width: ${props => props.style.minWidth};
    cursor: ${props => props.style.cursor};
    min-height: 1.5rem;
`

const Icon = styled.div`
    color: #F5F5F5;
    opacity: 0.8;
    font-size: var(--icon-size);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0.2rem;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Label = styled.div`
    max-width: 8rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const OptionTag = props => {
    const {
        option,
        onDelete,
        style
    } = props;
    const styles = Object.assign({}, defaultStyle, style)
    return (
        <Container style={styles}>
                <Label>{option['title']}</Label>
                {onDelete ? <Icon onClick={() => onDelete(option['value'])}><FaTimesCircle/></Icon> : null}
        </Container>
    )
}

export default OptionTag;